export const constructionType: any = {
    1: "Stone",
    2: "Panels",
    3: "Wooden",
    4: "Monolit",
}
